import { showLoginDialog } from '@/lib/apollo/common';
import {
  AccountBookOutlined,
  BugOutlined,
  CreditCardOutlined,
  EditOutlined,
  KeyOutlined,
  LoginOutlined,
  LogoutOutlined,
  QrcodeOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/AuthContext';
export function useMenuItems() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);

  const items = [
    {
      key: 'login',
      label: 'Login',
      hidden: () => user != null,
      icon: <LoginOutlined />,
      onClick: () => showLoginDialog(),
    },
    {
      key: 'register',
      label: 'Register',
      hidden: () => user != null,
      icon: <UserAddOutlined />,
      onClick: () => setShowRegisterDialog(true),
    },
    {
      key: 'edit',
      label: 'Edit Profile',
      hidden: () => user == null,
      icon: <EditOutlined />,
      onClick: () => navigate('/profile/edit'),
    },
    {
      key: 'usage',
      label: 'Usage',
      hidden: () => user == null,
      icon: <AccountBookOutlined />,
      onClick: () => navigate('/usage'),
    },
    {
      key: 'billing',
      label: 'Billing',
      hidden: () => user == null,
      icon: <CreditCardOutlined />,
      onClick: () => navigate('/billing'),
    },
    {
      key: 'api-key',
      label: 'Api Key',
      hidden: () => user?.role !== 'admin',
      icon: <KeyOutlined />,
      onClick: () => navigate('/api-key'),
    },
    {
      key: 'debug',
      label: 'Debug',
      hidden: () => user?.role !== 'admin',
      icon: <BugOutlined />,
      onClick: () => navigate('/debug'),
    },
    {
      key: 'referral-codes',
      label: 'Referral Codes',
      hidden: () => user?.role !== 'admin',
      icon: <QrcodeOutlined />,
      onClick: () => navigate('/admin/referral-codes'),
    },
    {
      key: 'logout',
      label: 'Logout',
      hidden: () => user == null,
      icon: <LogoutOutlined />,
      onClick: logout,
    },
  ];

  return {
    items: items
      .filter((r) => r.hidden == null || !r.hidden())
      .map((r) => ({
        ...r,
        hidden: undefined,
      })),
    showRegisterDialog,
    setShowRegisterDialog,
  };
}
